import React from 'react';
import classnames from 'classnames';
import {Select} from '@material-ui/core';
import './baseSelect.less';
import '../common.less';

export const BaseSelect = ({
    disabled, onChange, fullWidth = true, children, className, id, inputProps, classes = {}, dataWdio, SelectDisplayProps, ...rest
}) => {
    const containerClassName = classnames('base-select-container', className, {disabled});
    const selectClassName = classnames('base-select', classes.root, {disabled});
    const inputClassName = classnames('base-select-input', classes.input, {disabled});
    function handleChange(e) {
        if (disabled) return;
        onChange(e);
    }
    return (
        <Select
            variant="outlined"
            fullWidth={fullWidth}
            className={containerClassName}
            onChange={handleChange}
            inputProps={{...inputProps, id}}
            SelectDisplayProps={{...SelectDisplayProps, 'data-wdio': dataWdio}}
            disabled={disabled}
            classes={{...classes, root: selectClassName, input: inputClassName}}
            {...rest}
        >
            {children}
        </Select>
    );
};
export default BaseSelect;
